import produce from 'immer';

import State from '../core/State';
import { CheckDiscountCodeResult } from '../entity/DiscountCode';

export const setAssetFormTermAgreements = (isAgreed: boolean) => (state: State): State => {
  return produce(state, (draft) => {
    // stateにユーザーの同意の有無を保存する → stateの更新させる
    draft.projectEditing.isAssetTermAgreed = isAgreed;
  });
};

export const setIsRemovedLocalData = (isRemovedLocalData: boolean) => (state: State): State => ({
  ...state,
  projectEditing: {
    ...state.projectEditing,
    isRemovedLocalData,
  },
});

export const setDiscountCode = (discountCode: string, discountCodeResult: CheckDiscountCodeResult) => (
  state: State,
): State => {
  return produce(state, (draft) => {
    draft.projectEditing.discountCode = { discountCode, ...discountCodeResult };
  });
};

export const clearDiscountCode = () => (state: State): State => {
  return produce(state, (draft) => {
    draft.projectEditing.discountCode = null;
  });
};
